module.exports = __webpack_public_path__ + "static/media/PA-Icon-Fahrrad-neg.78d8000a.svg";